import React, { useState } from 'react';
import HeaderComponent from '../Shared/components/HeaderComponent';

import TabsEstadoCuenta from './TabsEstadoCuenta';
import FiltrosBusqueda from "./FiltrosBusqueda";
import { Breadcrumb, Layout } from 'antd';

const { Content } = Layout;

const EstadoCuenta = () => {

    const [filters, setFilters] = useState();

    const setFiltersData = (params) => setFilters(params);

    return (
        <>
            <Layout>
                <Content>
                    <Breadcrumb
                        className='breadcrumb'
                        items={[
                            { title: <a href="/home">Inicio</a> },
                            { title: "Estado de cuenta" }
                        ]}
                    />
                    <HeaderComponent title="Estado de cuenta" />

                    <FiltrosBusqueda
                        sendDataFilters={setFiltersData}
                    />

                    <TabsEstadoCuenta
                        filters={filters}
                    />

                </Content>
            </Layout>
        </>
    )
}

export default EstadoCuenta;